import { render } from "./permissions.vue?vue&type=template&id=07494637&scoped=true&lang=pug"
import script from "./permissions.vue?vue&type=script&lang=js"
export * from "./permissions.vue?vue&type=script&lang=js"

import "./permissions.vue?vue&type=style&index=0&id=07494637&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07494637"]])

export default __exports__